import React, {useState, useEffect, memo} from 'react';

import {
  Image,
  View,
  ActivityIndicator,
  StyleSheet,
  TouchableOpacity,
  Dimensions,
} from 'react-native';
import Markdown from 'react-native-markdown-display';

import {colors} from '../classes/Colors';
import {containerWidths} from '../constants/containerWidths';

const markdownStyles = {
  body: {color: colors.black, fontSize: 17},
  heading1: {color: colors.black, fontSize: 32, fontWeight: '700'},
  heading2: {color: colors.black, fontSize: 24, fontWeight: '700'},
  heading3: {color: colors.black, fontSize: 18, fontWeight: '700'},
  heading4: {color: colors.black, fontSize: 16, fontWeight: '700'},
  heading5: {color: colors.black, fontSize: 14, fontWeight: '700'},
  heading6: {color: colors.black, fontSize: 12, fontWeight: '700'},
};

const unescapeMarkdown = text =>
  text
    .replace(/\\\[/g, '[')
    .replace(/\\\]/g, ']')
    .replace(/\\\(/g, '(')
    .replace(/\\\)/g, ')')
    .replace(/\\!/g, '!');

// Custom image renderer that dynamically fetches image size
const RenderImage = ({src, onPress}) => {
  const [size, setSize] = useState(null);
  const [error, setError] = useState(false);

  const fallbackImage = require('../assets/Image_Loading_Placeholder_Large.png');

  useEffect(() => {
    const screenWidth = Dimensions.get('window').width;
    const maxWidth =
      screenWidth > containerWidths.maxWidthContainer
        ? containerWidths.maxWidthContainer
        : screenWidth * 0.85;

    Image.getSize(
      src,
      (width, height) => {
        const widthValue = width > maxWidth ? maxWidth : width;
        if (!size) {
          setSize({
            width: widthValue,
            height,
            aspectRatio: width / height,
          });
        }
      },
      () => {
        setError(true);
      },
    );
  }, [src]);

  if (!size || error) {
    return (
      <View style={styles.container}>
        <Image source={fallbackImage} style={styles.fallbackImage} />
      </View>
    );
  }

  // if (!size) {
  //   return (
  //     <View style={styles.container}>
  //       <ActivityIndicator style={{marginVertical: 10}} />
  //     </View>
  //   );
  // }

  return (
    <View style={styles.container}>
      <TouchableOpacity onPress={() => onPress(src)}>
        <Image
          source={{uri: src}}
          style={{
            width: size.width,
            // height: size.height,
            resizeMode: 'contain',
            aspectRatio: size.aspectRatio,
          }}
        />
      </TouchableOpacity>
    </View>
  );
};

const CustomMarkdown = memo(
  ({children, imageOnPress, getImageSrc, ...rest}) => {
    return (
      <Markdown
        mergeStyle
        style={markdownStyles}
        rules={{
          image: (node, children, parent, styles) => {
            if (!getImageSrc) {
              return null;
            }
            const src = getImageSrc(node.attributes.src);
            return <RenderImage key={src} src={src} onPress={imageOnPress} />;
          },
        }}
        {...rest}>
        {unescapeMarkdown(children)}
      </Markdown>
    );
  },
);

const styles = StyleSheet.create({
  container: {
    width: '100%',
    alignItems: 'center',
  },
  fallbackImage: {
    width: 300,
    height: 170,
    resizeMode: 'contain',
    alignSelf: 'center',
    marginVertical: 10,
    justifySelf: 'center',
  },
});

export default CustomMarkdown;
